/* 🤖 this file was generated by svg-to-ts */
export const matIconZoomOutMap: {
  name: 'zoom-out-map';
  data: string;
} = {
  name: 'zoom-out-map',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m15 3 2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"/></svg>`
};
